import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CardComponent } from '@domgen/dgx-fe-components/card';
import { IconComponent } from '@domgen/dgx-fe-components/icon';

@Component({
  selector:
    'us-registration-appliance-details-stepped-form-registration-code-confirmation-panel',
  standalone: true,
  imports: [IconComponent, CardComponent],
  templateUrl:
    './appliance-details-stepped-form-registration-code-confirmation-panel.component.html',
  styleUrls: [
    './appliance-details-stepped-form-registration-code-confirmation-panel.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplianceDetailsSteppedFormRegistrationCodeConfirmationPanelComponent {
  @Input() modelNumber?: string;
  @Input() serialNumber?: string;
  @Input() icon = 'washing-machine';
  @Input() appliance?: string;
  @Input() brandName?: string;
}
